module.exports = __webpack_public_path__ + "static/media/test3.5d14ca24.png";